import { render, staticRenderFns } from "./ResultComponent.vue?vue&type=template&id=f0cb05e8&scoped=true&"
import script from "./ResultComponent.vue?vue&type=script&lang=js&"
export * from "./ResultComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResultComponent.vue?vue&type=style&index=0&id=f0cb05e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cb05e8",
  null
  
)

export default component.exports